import MarketWidget from "../components/marketWidget/MarketWidget";
import { useState, useEffect } from 'react';
import TopHeader from "../components/topHeader/TopHeader";
import WalletWidget from "../components/walletWidget/WalletWidget";
import useProtectedClient from '../hooks/useProtectedClient';
import { BaseButton } from "../components/base";
import { useNavigate } from "react-router-dom";
import URIs from "../utils/uri";
import { useTheme, Typography } from "@mui/material";
import useAuth from "../hooks/useAuth";
import { getGoldBox } from "../api/goldbox/goldBoxApi";

const Home = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const {auth} = useAuth();
    const protectedClient = useProtectedClient();
    const [isLoading, setIsLoading] = useState(true)
    const [totalGold, setTotalGold] = useState(0);
    const [totalMoney, setTotalMoney] = useState(0);

    const fetchGoldBox = async () => {
        try {
            const res = await getGoldBox(protectedClient);
            setTotalGold(res.totalGoldWeight)
            setTotalMoney(res.totalValue)
        } catch (error) {
            
        } finally {
            setIsLoading(false);
        }
    };
    useEffect( () => {
        fetchGoldBox();
    }, []);
    return (
        <div>
            <TopHeader>
                {
                    (auth?.roles.includes(2) || auth?.roles.includes(3)) && 
                    <BaseButton
                        sx={{
                            width: "40%",
                            marginLeft: "10px",
                            height: "30px",
                            background: theme.palette.primary.main,
                            boxShadow: 'none'
                        }}
                        onClick={() => navigate(URIs.ADMIN.ROOT)}
                    >
                        <Typography
                            variant="caption2"
                        >
                            برو به پنل ادمین
                        </Typography>
                    </BaseButton>
                }
            </TopHeader>
            <WalletWidget totalGold={totalGold} totalGoldValue={totalMoney}/>
            <MarketWidget/>
        </div>
    )
}
export default Home;